<template>
  <div class="bodyGeneralColour px-4 py-1 shadow-md">
    <div>
      <div class="flex justify-between items-center">
        <img
          src="@/assets/images/iwc-logo2.png"
          alt="IWC Logo"
          class="h-16 object-contain"
        />
        <LogoutSvg class="text-white" @click="logoutHandler()" />
      </div>

      <div class="flex justify-between items-t">
        <div>
          <h2 class="text-dirtyWhite text-sm font-normal">
            {{ todayGreeting() }}
          </h2>
          <h1 class="text-white text-lg font-medium">
            {{ $store.state.userLogged.split(",")[1]?.trim().split(" ")[0] }}
          </h1>
        </div>
        <div class="flex items-center gap-3">
          <div class="flex rounded-full bg-white/20 p-1 backdrop-blur-sm">
            <button
              @click="setLanguage('en')"
              :class="[
                'px-3 py-1 text-xs font-medium rounded-full transition',
                selectedLanguage === 'en'
                  ? 'bg-white text-orange-500 shadow-sm'
                  : 'text-white hover:bg-white/10',
              ]"
            >
              🇺🇸 English
            </button>

            <button
              @click="setLanguage('ph')"
              :class="[
                'px-3 py-1 text-xs font-medium rounded-full transition',
                selectedLanguage === 'ph'
                  ? 'bg-white text-orange-500 shadow-sm'
                  : 'text-white hover:bg-white/10',
              ]"
            >
              🇵🇭 Filipino
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LogoutSvg from "@/components/svgs/LogoutSvg.vue";
import reusableBase from "@/utils/composables/format";
import { useRouter } from "vue-router";
import { inject, onMounted } from "vue";
import { useLanguage } from "@/utils/composables/useLanguage";
export default {
  components: { LogoutSvg },
  setup() {
    const { setLanguage, selectedLanguage } = useLanguage();
    const router = useRouter();
    const store = inject("$store");
    const { todayGreeting } = reusableBase();
    const logoutHandler = () => {
      localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN);

      if (store.state.schema === "iwc_prod") {
        router.push(`/auth?pid=${store.state.publicId}`);
      } else {
        router.push(`/ims`);
      }
    };
    onMounted(() => {
      const savedLanguage = localStorage.getItem("language");

      if (savedLanguage) {
        selectedLanguage.value = savedLanguage;
      }
    });

    return {
      todayGreeting,
      logoutHandler,
      selectedLanguage,
      setLanguage,
    };
  },
};
</script>
